module.exports = __webpack_public_path__ + "img/conf.2084dea2.png";